// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__vPK02","loading-wrapper":"Loading_loading-wrapper__U4DoS","loadingWrapper":"Loading_loadingWrapper__lWvkN"};